<template>
  <div class="app">
    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{ getTitleName() }} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search3"
               :label="this.$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-tooltip bottom>
              <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="insertTanitimTipOpen()" flat>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down"
                    > {{ $t('Add-v2', { value: getTitleName()}) }} </span
                  >
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
             <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: getTitleName()}) }}</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :rows-per-page-items="[50, 100]"
        :loading="progress"
        :items="items"
        :search="search3"
      >
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr item>
            <td class="text-xs-left">{{ props.item.Id }}</td>
            <td class="text-xs-left">{{ props.item.Ad }}</td>
            <td class="text-xs-left">{{ props.item.Aciklama }}</td>
            <td v-if="$route.params.id == 6" class="text-xs-left">
              {{ props.item.AcenteDepartman.EFaturaSeri }}
            </td>
            <td v-if="$route.params.id == 6" class="text-xs-left">
              {{ props.item.AcenteDepartman.MasrafMerkezi }}
            </td>
            <td class="justify-end align-center full-heigth layout px-0">
              <v-btn v-if="sayfayetki.Update" @click="editDialogOpen(props.item.Id)" icon small flat>
                <v-icon color="info">search</v-icon>
              </v-btn>
              <v-btn v-if="sayfayetki.Delete" @click="deleteDialogOpen(props.item.Id)" icon small flat>
                <v-icon color="warning">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }}
        </v-alert>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDataDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">{{ getTitleName() }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field v-model="loadData.Ad" :label="$t('Name_label')"></v-text-field>
          <v-textarea v-model="loadData.Aciklama" :label="$t('Description')"></v-textarea>
          <v-text-field
            v-if="$route.params.id == 302"
            v-model="loadData.Tevkifat.TevkifatOran"
            :label="$t('Ratio')"
          ></v-text-field>
          <v-text-field
            v-if="$route.params.id == 6"
            v-model="loadData.AcenteDepartman.EFaturaSeri"
            :label="$t('E-Invoice-Serial')"
          ></v-text-field>
          <v-text-field
            v-if="$route.params.id == 6"
            v-model="loadData.AcenteDepartman.MasrafMerkezi"
            :label="$t('Expense-Center-v2')"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="editDataDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="UpdateTanitimTip()">
            {{ $t('save_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="insertDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text"> {{ getTitleName() }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field v-model="loadData.Ad" :label="$t('Name_label')"></v-text-field>
          <v-textarea v-model="loadData.Aciklama" :label="$t('Description')"></v-textarea>
          <v-text-field
            v-if="$route.params.id == 302"
            v-model="loadData.Tevkifat.TevkifatOran"
            label="Oran"
          ></v-text-field>
          <v-text-field
            v-if="$route.params.id == 6"
            v-model="loadData.AcenteDepartman.EFaturaSeri"
            :label="$t('E-Invoice-Serial')"
          ></v-text-field>
          <v-text-field
            v-if="$route.params.id == 6"
            v-model="loadData.AcenteDepartman.MasrafMerkezi"
            :label="$t('Expense-Center-v2')"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="insertDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="insertTanitimTip()">
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text"> {{ getTitleName() }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t('Are-you-sure-want-delete') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="deleteTanitimTip()"> {{ $t('Delete') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tool from "@/components/app/coper/tools";
import helpers from "@/components/app/customcomp/helpers.js"

export default {
  name: "coper-tanitimlar-parametre",
  data() {
    return {
      tanitimTip: this.$route.params.id,
      editDataDialog: false,
      insertDialog: false,
      deleteDialog: false,
      deleteId: 0,
      headers: [],
      headersStandart: [
        {
          text: "İd",
          value: "ID",
          align: "left",
        },
        {
          text: this.$t("Name_label"),
          value: "Ad",
          align: "left",
        },
        {
          text: this.$t('Description'),
          value: "Aciklama",
          align: "left",
        },
        {
          text: this.$t('Process'),
          value: "İslem",
          align: "right",
        },
      ],
      headersAcente: [
        {
          text: "İd",
          value: "ID",
          align: "left",
        },
        {
          text: this.$t("Name_label"),
          value: "Ad",
          lenght: "%25",
          align: "left",
        },
        {
          text: this.$t('Description'),
          value: "Aciklama",
          lenght: "%25",
          align: "left",
        },
        {
          text: this.$t('E-Invoice-Serial') ,
          value: "EFaturaSeri",
          align: "left",
        },
        {
          text: this.$t('Expense-Center-v2'),
          value: "MasrafMerkezi",
          align: "left",
        },
        {
          text: this.$t('Process'),
          value: "İslem",
          align: "right",
        },
      ],
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      loading: false,
      progress: false,
      items: [],
      search3: "",
      loadData: {
        Id: null,
        Ad: null,
        Aciklama: null,
        AcenteDepartman: {
          MasrafMerkezi: null,
          EFaturaSeri: null,
        },
        Tevkifat: null,
      },
    };
  },
  components: {
    tool,
  },
  methods: {
    deleteDialogOpen(val) {
      this.deleteDialog = true;
      this.deleteId = val;
    },
    deleteTanitimTip() {
      let params = {
        TanitimTip: this.tanitimTip,
        Id: this.deleteId,
      };
      tool.http_post(this, "GenelTipTanitimDelete", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getTanitimList();
            this.deleteDialog = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    insertTanitimTip() {
      let params = {
        TanitimTip: this.tanitimTip,
      };
      params = Object.assign(params, this.loadData);

      tool.http_post(this, "GenelTipTanitimInsert", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getTanitimList();
            this.insertDialog = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    insertTanitimTipOpen() {
      this.loadData.Id = null;
      this.loadData.Ad = null;
      this.loadData.Aciklama = null;
      this.loadData.AcenteDepartman.EFaturaSeri = null;
      this.loadData.AcenteDepartman.MasrafMerkezi = null;
      this.insertDialog = true;
    },
    UpdateTanitimTip() {
      let params = {
        TanitimTip: this.tanitimTip,
      };
      params = Object.assign(params, this.loadData);

      tool.http_post(this, "GenelTipTanitimEdit", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.editDataDialog = false;
            this.getTanitimList();
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    editDialogOpen(val) {
      let params = {
        ID: val,
        TanitimTip: this.tanitimTip,
      };
      tool.http_post(this, "GenelTipTanitimLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.loadData = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );

      this.editDataDialog = true;
    },
    getTanitimList() {
      this.progress = true;
      let params = {
        TanitimTip: this.tanitimTip,
      };

      tool.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.items = response.body.data;
            this.progress = false;
          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    getTitleName() {
      switch (Number(this.tanitimTip)) {
        case 0:
          return "Bölge Kodu";
        case 1:
          return this.$t('Department-Code-Bolum');
        case 2:
          return "Yonetim Kodu";
        case 3:
          return this.$t('Department-Code');
        case 4:
          return "Alt Departman Kodu";
        case 5:
          return "Vize Tipi Kodu";
        case 6:
          return this.$t('Agency-Department');
        case 7:
          return this.$t('Reason-Code-v2');
        case 8:
          return "Otel Fiyat Kodu";
          case 9:
          return "Paket Tur Kategori";
          case 10:
          return "Paket Tur Ürün Grup";
          case 11:
          return "Paket Tur Ana Fiyat Grup";
          case 12:
          return "Paket Tur Alt Fiyat Grup";
        default:
          break;
      }
    },
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth("coper-tanitimlar-parametrelist");

    if (this.sayfayetki.Status == true) {
          this.getTanitimList();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          } 
        });
    }

    switch (Number(this.tanitimTip)) {
      case 6:
        this.headers = this.headersAcente;
        break;
      default:
        this.headers = this.headersStandart;
        break;
    }
  },
};
</script>

<style>
</style>